module.exports = __webpack_public_path__ + "static/media/support-thumb-2.60bbba0a.jpg";